/* eslint-disable  */

export default {
  common: {
    add: 'Hinzufügen',
    read_more: 'erweitern',
    read_less: 'reduzieren',
    as_seen_on: 'Bekannt aus',
    more_info: 'Mehr Info',
    required_field: 'Pflichtfelder',
    submit: 'Anwenden',
    reset: 'Zurücksetzen',
    search: 'Suche',
    back: 'Zurück',
    save_money: 'Spare',
    more: 'Weitere',
    more2: 'Mehr',
    next: 'Weiter',
    oder: 'oder',
    spare: 'SPARE',
    load_more: 'Mehr laden',
    close: 'Schließen',
    here: 'hier',
    email: 'EMail',
    with: 'Mit',
    soldout: 'Ausverkauft',
    soldout2: 'Ausgebucht',
    all_motifs: 'Alle Motive',
    all: 'Alle',
    location: 'Location',
    welcome_by_AN: 'Willkommen bei ArtNight!',
    select_city_content:
      'Wähle deinen nächstgelegenen Ort, um direkt zu den verfügbaren Malkurse in deiner Stadt zu gelangen!',
    later: 'Später',
    city: 'Stadt',
    view_AN: 'ArtNights anzeigen',
    remove: 'Entfernen',
    share_artnight: 'Teile diese ArtNight',
    save: 'Speichern',
    save_selection: 'Auswahl speichern',
    page: 'Seite',
    out_of: 'von',
    code: 'Code',
    give_feedback: 'Feedback abgeben',
    multi_cities: '{cities_count} Stadt | {cities_count} Städte'
  },
  online_badge: {
    our: 'Unsere',
    more: 'More',
    online: 'Online'
  },
  menu: {
    online_team_events: 'Online Team Events',
    team_events: 'Gruppen & Firmen',
    team_events2: 'Gruppenevents',
    team_events3: 'Private {brand}s',
    team_events_virtuelle: 'Virtuelle Team Events',
    bachelorette_party: 'Junggesellinnenabschiede',
    about_us: 'Über uns',
    press: 'Presse',
    terms: 'AGB',
    impressum: 'Impressum',
    privacy: 'Datenschutz',
    voucher: 'Gutschein',
    gift_voucher: 'Geschenk-Gutschein',
    subtitle: 'Digitaler Gutschein zum Ausdrucken',
    voucher_as_gift: 'Gutschein verschenken',
    personalised_voucher: 'Personalisierter-Gutschein',
    giftbox: 'Gutscheinbox',
    ticket_rebooking: 'Ticket Umbuchung',
    become_artist: 'Künstler werden',
    become_acryl_artist: 'Acryl Künstler',
    become_handlettering_artist: 'Handlettering Künstler',
    become_host: 'Host werden',
    become_baker: 'Kursleitung werden',
    become_location: 'Location werden',
    help_contact: 'Hilfe & Kontakt',
    jobs: 'Jobs',
    blog: 'Blog',
    faq: 'FAQ',
    contact: 'Kontakt',
    at_home: '{brand}s für zuhause',
    livestream: '{brand} Live Stream',
    live_online: 'Online {brand}',
    live_online2: 'Live Online {brand}',
    online_events: 'Online Malkurs',
    video_tutorials: 'Videokurse',
    baking_tutorials: 'Backkurse',
    material_brand: '{brand} Materialien kaufen',
    material: 'Material',
    email_coach: 'E-Mail Coach: Menschen zeichnen'
  },
  errors: {
    general: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    message_404: 'Leider können wir die gesuchte Seite nicht finden.'
  },
  category: {
    new_label: 'JETZT NEU',
    material_description:
      'Mit unseren hochwertigen Materialien steht dir nichts mehr im Weg deiner Kreativität freien Lauf zu lassen!',
    live_label: 'Unsere {type} {brand}s',
    motiv_page_title: 'ArtNight: Malkurse in deiner Nähe',
    city_page_title: 'ArtNight: Malkurse in {city}',
    event_page_title: 'ArtNight: Male das Motiv der {theme} in {city}',
    online_event_page_title: 'ArtNight: Male das Motiv der {theme} Online',
    meta_event_description: 'Male mit uns das Motiv des {theme} am {date} im {location} in {city}',
    meta_online_event_description: 'Male mit uns am {date} Uhr das Motiv des {theme} online.',
    meta_motiv_description:
      'Wähle aus einer Vielzahl von ArtNight-Motiven und erlebe Malen in über 60 Städten. Perfekt für einen entspannten Abend voller Kreativität!',
    events_page_title: 'Malkurse in deiner Nähe | ArtNight',
    meta_description:
      'Wähle aus einer Vielzahl von ArtNight-Motiven und erlebe Malen in {city}. Perfekt für einen entspannten Abend voller Kreativität!',
    meta_online_description:
      'Wähle aus einer Vielzahl von ArtNight-Motiven und erlebe das Malen ganz bequem von zu Hause aus. Perfekt für einen entspannten Abend voller Kreativität!',
    meta_title: 'Malkurse in {city} ',
    live_meta_title: 'ArtNight: Online-Malkurse für zu Hause',
    artnight_live_description:
      'Entdecke, wie auf einer ArtNight, den Spaß am Malen, als interaktives Erlebnis live von zu Hause aus!\u2028Unsere Künstler führen dich per Livestream Schritt für Schritt durch dein gewähltes Motiv. Du kannst jederzeit Fragen stellen und dich mit den anderen Teilnehmern austauschen. Für eine Online ArtNight brauchst du eine Leinwand (30x40cm), Acrylfarben und Pinsel. Optional kannst du die Materialien beim Kauf direkt mitbestellen. Nach Kaufabschluss erhältst du einen Link, über den du dich in den Livestream der ArtNight einwählen kannst.',
    search_no_cities: 'Es gibt keine Stadt namens {query}.',
    search_title: 'Stadt eingeben',
    events_in: 'Malkurse in {city}',
    filters: {
      label: 'Filter',
      button_text: 'Filter',
      reset: 'Filter zurücksetzen',
      empty: 'Keine Ergebnisse',
      type: {
        regular: 'Reguläre {brand}',
        regular_text: 'Das klassische {brand} Erlebnis, wofür man uns kennt.',
        charity: 'Charity {brand}',
        charity_text:
          'Bei einer Charity {brand} wirst du definitiv für den guten Zweck malen! 5% aller Einnahmen gehen an eine Wohltätigkeitsorganisation.',
        small_group: 'Kleine Gruppe {brand}',
        small_group_text:
          'Unsere kleine Gruppen {brand} ermöglichen mehr individuelle Betreuung mit maximal 15 Teilnehmern pro Event.',
        collaboration: 'Kollaboration {brand}',
        collaboration_text:
          'Bei unseren Kollaboration arbeiten wir mit exklusiven Unternehmen zusammen, um dir ein einzigartiges {brand} Erlebnis zu bieten.'
      },
      skill: {
        beginner: 'Anfänger',
        intermediate: 'Fortgeschritten',
        advanced: 'Profi'
      },
      sort: {
        standard: 'Standard-Sortierung',
        desc: 'Neueste bis älteste',
        asc: 'Älteste bis neueste'
      },
      filter: {
        city: 'Stadt',
        date: 'Datum',
        date_placeholder: 'Wählen Sie die passenden Tage für Sie.',
        skill: 'Level',
        type: 'Event Typ',
        host: 'Künstler:in',
        theme: 'Motiv',
        theme_category: 'Kategorien',
        sort: 'Sortieren'
      },
      dayNames: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
      monthNames: [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
      ]
    },
    kids_events: {
      title:
        'ArtNight ist der perfekte Malkurs für Kinder ab 5 Jahren, die ihre kreative Seite entdecken möchten. Unsere erfahrenen ArtNight Künstler führen die Kinder in die Welt der Farben und Formen ein und unterstützen sie dabei, ihre eigenen künstlerischen Fähigkeiten zu entwickeln.',
      subtitle:
        'Durch das Malen und Gestalten lernen die Kinder, ihre Gedanken und Gefühle auszudrücken und sich besser auf eine Aufgabe zu konzentrieren.',
      meta: {
        title: 'Gemeinsame Malkurse für Kinder und Eltern | ArtNight',
        description:
          'Male mit deinem Kind zwei tolle Bilder und nehmt eure Kunstwerke anschließend als schöne Erinnerung mit nach Hause!'
      }
    },
    discovery_banner: {
      title: 'Malkurse für Gruppen und Firmen',
      text: 'Das kreativste Teamevent für jeden Anlass!',
      button: 'Mehr Infos und Terminanfrage'
    }
  },
  voucher: {
    seo: {
      title: 'ArtNight: Kaufe einen Gutschein, um Kreativität zu verschenken',
      description:
        'Verwöhne dich oder einen lieben Menschen mit einem ArtNight-Erlebnis. Einlösbar für jeden ArtNight-Malkurs in über 60 Städten oder online.'
    },
    price_explainers: {
      0: '1 Online Ticket',
      1: '1 Ticket vor Ort',
      2: '2 ArtNight Kids Tickets',
      3: '2 Tickets vor Ort',
      4: '10 x Online Tickets',
      5: '10 x ArtNight vor Ort',
      6: 'test'
    },
    voucher: 'Gutschein',
    digital: 'Digitaler Gutschein',
    physischer: 'Physischer Gutschein',
    multiticket: 'Multiticket',
    hero_title: 'Ein {brand} Gutschein ist das perfekte Geschenk!',
    discount: 'Angebot!',
    discount_title: '12 Tickets zum Preis von 10',
    discount_text:
      'Erhalte beim Kauf unserer Jahreskarte für ArtNight Events vor Ort oder Online 12 Tickets für den Preis von nur 10. Die zwei Gratis-Tickets erhältst du als Rabattcodes zusätzlich per E-Mail.',
    product_options: {
      header: 'Grußbotschaft',
      voucher: 'Grußbotschaft'
    },
    delivery_text: 'Direkt nach dem Kauf senden wir dir den Gutschein per E-Mail zu.',
    multitickets: 'Multitickets',
    choose_amount: 'Wähle den Betrag',
    choose_motive: 'Wähle ein Gutschein Motiv aus',
    choose_message: 'Personalisiere deinen Gutschein mit einer Grußbotschaft',
    write_message: 'Eigenen Text schreiben',
    write_message_placeholder: 'Grußbotschaft schreiben...',
    characters_left: 'Zeichen übrig',
    usability_warning:
      'Geschenkgutscheine können für alle Produkte eingelöst werden, außer für weitere Geschenkgutscheine.',
    artnight: {
      listing_hero_headline: 'Für alle die Kreativität schenken wollen.',
      grid_title: 'Entdecke weitere <br>{brand}-Gutscheine',
      listing_hero_content:
        'Mit unseren ArtNight-Gutscheinen entdeckt jede:r seine kreative Ader – das perfekte Geschenk!',
      listing_hero_list_items: [
        'Ein unvergessliches Erlebnis in Gemeinschaft - denn zusammen kreative Zeit zu verbringen ist mit das Wertvollste.',
        'Individuell und einzigartig - am Ende hat jeder seine eigene Kreation zum Verschenken oder zum Dekorieren der eigenen vier Wände.',
        'Das Rund-Um-Sorglos Paket - unsere Künstler bringen alles und leiten euch Schritt für Schritt ins Ziel.'
      ],
      voucher_personalisation_options: [
        {
          name: 'Geburtstag',
          text: "Alles Liebe zum Geburtstag! Gönn' dir eine kreative Pause bei einer ArtNight."
        },
        {
          name: 'Muttertag',
          text: 'Liebe Mama, ich wünsche dir alles Liebe zum Muttertag! Du hast dir eine kleine kreative Pause verdient.'
        },
        {
          name: 'Weihnachten',
          text: 'Frohe Weihnachten! Viel Spaß bei einer kreativen Pause bei einer ArtNight.'
        },
        {
          name: 'Dankeschön',
          text: 'Ein kleines Dankeschön für dich! Du hast dir eine kreative Pause verdient.'
        },
        {
          name: 'Für Kollegen',
          text: 'Danke für die tolle Zusammenarbeit - wir finden, du hast dir eine kreative Pause bei einer ArtNight verdient.'
        },
        {
          name: 'Valentinstag 💖',
          text: 'Schönen Valentinstag! Du bist etwas ganz Besonderes und hast dir eine kreative Pause bei einer ArtNight verdient.'
        },
        {
          name: 'Unausgefüllt',
          text: ' '
        }
      ],
      hero_text: 'Zeit fürs perfekte Geschenk!',
      giftcard_text:
        'Wähle einen passenden Betrag für deinen Gutschein aus und personalisiere ihn nach Belieben mit einem Motiv und einer persönlichen Grußbotschaft.',
      multiticket_text:
        'Multitickets enthalten mehrere Gutscheincodes mit einem Wert von jeweils {unitPrice} €. Je größer das Multiticket, desto mehr sparst du!'
    },
    personalise: 'Personalisiere deinen Geschenkgutschein',
    amount: 'Wähle einen Betrag aus',
    amount_subtitle: 'Der gewählte Gutscheinwert ist für alle ArtNight Malkurse einlösbar',
    headline: 'Wie möchtest du den Gutschein erhalten?',
    design: 'Wähle ein Design für deinen Gutschein aus',
    receive: 'Wer wird beschenkt?',
    message: 'Füge eine Nachricht hinzu',
    emoji_message: 'Emojis werden nicht angezeigt',
    sending_option_title: 'Geschenkkarten-Option',
    sending_option_subtitle: 'Wähle zwischen einem digitalen oder physischen Gutschein',
    sending_options: {
      pdf: {
        title: 'Digitaler Gutschein',
        subtitle: 'Zu Hause ausdrucken',
        asterisk: '<b>+ 8 €</b>'
      },
      card: {
        title: 'Physischer Gutschein',
        subtitle: 'Versand innerhalb DE/AT'
      }
    },
    personalised_msg_title: 'Füge eine Nachricht hinzu',
    personalised_msg_subtitle: 'Persönliche Nachricht schreiben (optional)',
    text_area_subtitle: '{number} Zeichen übrig',
    summary_title: 'Fertig!',
    summary_subtitle: 'Deine personalisierte Geschenkkarte:',
    value: 'Wert:',
    option: 'Option:',
    message_summary: 'Nachricht:',
    image_legend_pdf: {
      title: 'Digitaler Gutschein',
      subtitle: 'Zum sofort Ausdrucken'
    },
    image_legend_physical: {
      title: 'Physischer Gutschein',
      subtitle: 'Unikat: Mit edlem handbemalten Kunstumschlag'
    }
  },
  event: {
    find_your_artnight: 'Deine ArtNight finden',
    copyright_image: 'Quelle des Beispielbildes: {content}',
    copyright_theme: 'Quelle des Motivs: {content}',
    theme_included_title: 'Was alles dazu gehört',
    theme_learnings_title: 'Was du lernen wirst',
    livestream_from: 'Live from {city}',
    online_text: 'Online ArtNight',
    outdoor_text: '{brand} im Freien',
    collaboration_text: 'Kollaboration',
    collaboration_with_text: 'Kollaboration mit {name}',
    select_date_text: 'Bitte wähle ein Datum',
    more_events_text: 'Weitere Termine',
    upsell_header_text: 'Passend dazu',
    sales_stopped_text: 'Verkaufsschluss',
    time_text: '{start} - {end} Uhr',
    reviews_title: 'Bewertungen',
    sold_out_text: 'Ausverkauft',
    ticket_qty_text: '{qty} Ticket | {qty} Tickets',
    last_chance_text: 'Nur noch {qty} Ticket! | Nur noch {qty} Tickets!',
    artnight_meta_title: 'Am {date} um {time} malt {host} mit euch das Motiv {theme}',
    about_materials_title: 'Die Materialien',
    about_bundle_title: 'Über dieses Bundle',
    price_message: 'Teil',
    two_days_event: '2-teiliges Event',
    select_date: 'Datum wählen',
    select_date_empty_state_with_city_text:
      'Sorry, wir bieten derzeit keine weiteren Events mit diesem Motiv in {city} an.',
    select_date_empty_state_text: 'Sorry, wir bieten derzeit keine weiteren Events mit diesem Motiv an.',
    select_city: 'Stadt wählen',
    price_per_ticket: 'Preis pro Ticket',
    no_venue: 'Ort wird noch bekanntgegeben',
    features: {
      title: 'Das Wichtigste vorab',
      basic_level: 'Anfänger Level',
      pro_level: 'Fortgeschrittenes Level',
      advanced_level: 'Profi',
      materials: {
        shipment: 'Material nach Hause',
        purchase: 'Bestell dir unser Materialset',
        more_info: 'Mehr Materialinformationen findest du hier'
      },
      materials_included: 'Alle Materialien inklusive',
      materials_not_included:
        '<a href="https://help.artnight.com/hc/de/articles/12455852875036-Was-ist-eine-Online-ArtNight" target="blank" class="cl-primary ff-bold">Mehr Materialinformationen findest du hier</a>',
      painting_info: 'Motiv kann mit Acryl, Wasser oder Lebensmittelfarbe gemalt werden',
      material_set:
        'Wir schicken dir gerne unser ArtNight Material nach Hause: <a href="/products/artnight-acryl-material-kit/" class="cl-primary ff-bold">Bestell dir unser Materialset</a>',
      with_recipe: 'Inklusive Rezept & Einkaufsliste',
      host: 'Mit {host}',
      fun: 'Sorgloser Spaß.',
      corona_notice: 'Unser Konzept für die Sicherheit unserer Teilnehmer',
      video_course: 'Male in deinem Tempo, wann und wo du willst',
      livestream_text:
        'Für die perfekte Vorbereitung erhältst du von uns zwei Videokurse gratis obendrauf: Pinseltechnik \uD83D\uDD8C und Farbenlehre \uD83C\uDFA8.',
      duration_text: '<strong>Dauer</strong>: ca. {min} Min',
      preparation_text: '<strong>Vorbereitungszeit</strong>: {min} Min',
      language_text: 'Sprache: {languages}',
      languages: {
        German: 'Deutsch',
        English: 'Englisch'
      },
      short_languages: {
        de: 'Deutsch',
        Deutsch: 'Deutsch',
        german: 'Deutsch',
        en: 'Englisch',
        Englisch: 'Englisch',
        english: 'Englisch',
        fr: 'Französisch',
        Französisch: 'Französisch',
        sign: 'Signs'
      },
      levels: {
        1: 'Alle Level, auch Neueinsteiger:innen',
        2: 'Fortgeschrittenes Level, ideal für alle die schon mal einen Pinsel in der Hand hatten',
        3: 'Profi Level, ideal für alle mit ArtNight oder anderweitige Malerfahrung',
        4: 'because it is needed on staging'
      },
      description_title: 'Was {text} erwartet',
      description_title_text: 'dich',
      buy_group_booking: 'Privates Gruppenevent anfragen',
      buy_gift_card: 'Geschenk-Idee? ArtNight verschenken'
    },
    levels: {
      1: 'Einfach',
      2: 'Fortgeschrittene',
      3: 'Profi'
    },
    bundles: {
      title: 'What’s included?',
      title_parent: 'Auch Teil von:',
      more_link: 'Mehr erfahren'
    },
    subtitles: {
      video_course: 'Enthält {qty} Videokurs | Enthält {qty} Videokurse',
      artnight: 'Malen mit Acryl',
      handlettering: 'Lerne Handlettering und Brushlettering',
      'handlettering-pro': 'Lerne fortgeschrittene Techniken zu Handlettering und Brushlettering'
    },
    segmentation_label: {
      kompakt: 'Kompakt',
      compact: 'Kompakt',
      classic: 'Classic',
      premium: 'Premium'
    }
  },
  theme: {
    seo_title: 'ArtNight: {theme} Malkurs',
    seo_description: 'Malen mit ArtNight: Das {theme} motiv in über 60 Städten in Deutschland & Österreich erhältlich'
  },
  events: {
    seo_title: '{title} - ArtNight am {date}, {venue}',
    seo_online_title: '{title} - Online ArtNight am {date}',
    seo_description: 'Am {date} um {time} malt {host} mit euch das Motiv {title} - {venue} in {city}',
    seo_online_description: 'Am {date} um {time} malt {host} online mit euch das Motiv {title}',
    more_info: 'Mehr Info',
    back_to_events: 'Zu den Events',
    regular_upcoming_in: '{brand}s in ',
    upcoming_in: '{brand}s in',
    upcoming_in2: 'Zukünftige {brand}s in',
    upcoming_in3: 'Zukünftige {brand}s in',
    more_upcoming_in: '{brand}s in',
    upcoming: 'Zukünftige {brand}s',
    upcoming_from: 'Weitere {brand}s von',
    upcoming_online: 'Weitere Online {brand}s',
    no_more_events: 'Weitere Events sind in Planung.',
    no_more_events_with_filters: "Ups, da gibt's keine ArtNights mit dieser Auswahl.",
    upcoming_host: 'Weitere Motive mit Host {host}',
    upcoming_city: 'Weitere Artnights in {city}',
    no_results: 'Keine Ergebnisse gefunden!',
    load_more: 'Mehr anzeigen',
    price_unit: '/ Ticket',
    events_in: 'Malkurse in',
    nearby_you: 'deiner Nähe',
    last_viewed: 'Zuletzt gesehen'
  },
  venue: {
    label: 'Die Location',
    undefined_label: 'Location Ausstehend',
    undefined_description:
      'Die genaue Location teilen wir dir spätestens 48 Stunden vor Eventbeginn per Email und hier auf der Webseite mit. Dein Event wird auf jeden Fall in {city} stattfinden!',
    upcoming_events: 'Weitere {brand}s in dieser Location',
    subtitle: 'Deine Location',
    open_map: 'Auf Google Maps anzeigen',
    has_parking: 'Parkplätze vorhanden',
    has_accessibility: 'Zugänglich für behinderte Menschen',
    type: 'enue type (e.g. bar or restaurant)'
  },
  host: {
    label: 'Host',
    course_management: 'Kursleitung',
    events_held_label: 'Gegebene Events',
    artnight_label: 'Mit deinem Künstler:in',
    search_host: 'Suche eine:n Künstler:in',
    meet: 'Lerne deinen Host',
    know: 'kennen'
  },
  rebooking: {
    booking_number: 'Buchungsnummer',
    resend_booking_title: 'Buchungsbestätigung anfordern',
    resend_booking_subtitle:
      'Du findest deine Buchungsbestätigung nicht? Dann gib bitte deine E-Mail Adresse ein, die du bei deiner Buchung verwendet hast und wir schicken dir in den nächsten Minuten deine Buchungsbestätigung zu.',
    title: 'Ticketumbuchung',
    subtitle: 'Um deine Buchung zu ändern, gib bitte deine E-Mail-Adresse und Bestellnummer ein.',
    reason_label: 'Nenne uns den Grund der Umbuchung:',
    reason_placeholder: 'Grund der Umbuchung',
    info_line_1: 'Wichtige Informationen',
    info_line_2:
      'Die Realtainment GmbH ist rechtlich nicht dazu verpflichtet, eine Umbuchung der Tickets zu ermöglichen*. ',
    info_line_3:
      'Eine Umbuchung ist aus Kulanz nur bis zu <b>48 Stunden</b> vor Stattfinden des Events möglich. Wenn du dich für eine Umbuchung entscheidest, bekommst du einen Gutscheincode zugeschickt, mit dem du eine neue ArtNight buchen kannst. ',
    info_line_4: 'Details zu unseren Stornierungebedingungen findest du {rebooking_link}.',
    info_line_5: '*AGB der Realtainment GmbH',
    info_line_6: 'Weitere Fragen?',
    info_line_7: 'Kontaktiere gerne unser Team über dieses {support_link}.',
    contact_form: 'Kontaktformular',
    button_next: 'Weiter',
    button_back: 'Zurück',
    selection_title: 'Tickets auswählen',
    selection_subtitle: 'Wähle die Tickets aus, die du gerne umbuchen möchtest.',
    confirm_title: 'Danke. Du hast es fast geschafft!',
    confirm_subtitle: 'Bitte klicke den Link in deiner Stornierungsbestätigung um den Vorgang abzuschließen.',
    reason_title: 'Grund für die Umbuchung',
    reason_subtitle:
      'Lass uns wissen, warum du deine Tickets umbuchen musst. Bitte beachte, dass dieser Schritt erforderlich ist, um deine Gutscheine zu erhalten.',
    thankyou_title: 'Umbuchung bestätigt',
    thankyou_subtitle:
      'Yipeee. Du hast soeben von uns eine Email erhalten, um Deine Stornierung noch einmal zu bestätigen. Bitte überprüfe auch deinen Spam-Ordner. Nach Bestätigung bekommst Du direkt eine Email mit Deinem neuen Gutscheincode zugeschickt.',
    warning_title: 'Bitte beachten',
    warning_text:
      'Wir schicken dir eine E-Mail, um die Umbuchung dieser Tickets zu bestätigen. Klicke bitte auf den Link in der E-Mail, um deine neuen Gutscheine zu erhalten.',
    warning2_title: 'Umbuchung ausstehend',
    warning2_text:
      'Bitte überprüfe deine E-Mails, um diese Umbuchung zu bestätigen und Gutscheine für deine nächste ArtNight zu erhalten.',
    reason_options: {
      corona: 'Coronavirus',
      illness: 'Krankheit',
      prevented: 'Zeitlich verhindert',
      another_interest: 'Interesse an einer anderen {brand}',
      order_mistake: 'Fehlbuchung',
      change: 'Änderung der Uhrzeit/Datum/Location der {brand}',
      other: 'Sonstiges'
    },
    email_success_thank_you: 'Vielen Dank für deine Anfrage!',
    email_success_text:
      'Sofern wir eine Buchung mit deiner E-Mailadresse finden können, senden wir dir deine Bestellbestätigung in wenigen Minuten erneut zu. Solltest du keine E-Mail erhalten, prüfe bitte die Richtigkeit deiner E-Mailadresse und deinen Spam-Ordner. Bei fragen kannst du dich jederzeit an unseren Kundenservice wenden:',
    help_and_contact: 'Hilfe & Kontakt'
  },
  cancellations: {
    thankyou_text: 'Vielen Dank für Deine Rückmeldung!'
  },
  cart: {
    title: 'Warenkorb',
    warning: 'Deine Tickets sind für 30 Minuten reserviert.',
    open: 'Warenkorb öffnen',
    button_text: 'In den Warenkorb',
    price_per_item_text: 'Stückpreis',
    added_voucher_text: 'Angewendeter Gutscheincode',
    total_text: 'Gesamtsumme',
    subtotal_text: 'Zwischensumme',
    qty_text: 'Anzahl',
    voucher_code_label: 'GUTSCHEINGESCHENK',
    empty_text: 'Dein Warenkorb ist derzeit leer.',
    to_checkout_text: 'Zur Kasse gehen',
    continue_shopping_text: 'Weiter shoppen',
    pay_button: 'Bezahlen',
    add_to_cart_text: 'Jetzt buchen | Jetzt kaufen',
    empty_cart_text: 'Dein Einkaufswagen ist derzeit leer. Bitte füge noch Produkte hinzu, bevor du zur Kasse gehst',
    qty_adjusted_text: 'Die Menge hat sich geändert. Nur noch {qty} Tickets übrig!',
    sold_out: 'Ausverkauft',
    not_available: 'Nicht verfügbar',
    remove_ticket: 'Löschen',
    view_motiv: 'Motiv ansehen',
    find_ticket: 'Ticket finden'
  },
  coupons: {
    add_coupon_text: 'Du hast einen Gutscheincode? Klicke hier!',
    add_coupon_info_text:
      "Rabattaktionen sind nicht mit anderen Coupons kombinierbar. <br>Details zum Zahlen mit Gutscheinen findest du <a href='https://help.artnight.com/de/support/solutions/folders/42000106111' target='_blank'><u>hier</u></a>.",
    input_placeholder: 'Code eingeben',
    success_text: 'Gutschein-Code erfolgreich angewendet.',
    error_text: 'Der angegebene Gutscheincode ist nicht gültig.',
    coupon_subtext:
      'Rabattcodes und Gutscheincodes können für den Kauf eines Geschenkgutscheins nicht verwendet werden. Du kannst nur einen Rabattcode pro Bestellung verwenden.'
  },
  checkout: {
    checkout_button: 'Zur Kasse gehen',
    title: 'Dein Warenkorb',
    order_as_company: 'Als Unternehmen bestellen',
    payment_title: 'Zahlungsart',
    billing_title: 'Persönliche Angaben',
    order_title: 'Deine Bestellung',
    order_button_submit: 'Bestellung abschicken',
    free_order_button_submit: 'Bestellung kostenlos abschicken',
    select_payment_gateway: 'Wähle deine bevorzugte Zahlungsmethode',
    shop_more: 'Ich möchte noch weitershoppen',
    newsletter_check:
      'Für den Newsletter anmelden und über Aktionen, Rabatte, Gewinnspiele und neue Termine informiert werden.',
    terms_check: 'Ich habe die {link} gelesen und stimme ihnen zu. *',
    terms_link: 'Geschäftsbedingungen',
    credit_card: 'Kreditkarte',
    coupon_text: 'Gutschein eingeben',
    email_text: 'Hier werden wir dir die Bestätigung deiner Bestellung hinsenden.',
    select_payment_text: 'Zahlungsart auswählen',
    validation_failed: 'Bitte füllen Sie die Felder aus.',
    voucher_upsell: {
      text: 'Wenn du möchtest, kannst du hier deiner Bestellung einen {brand} Gutschein hinzufügen.'
    },
    giftcard_warning:
      'Ein Geschenkgutschein kann für alle Produkte verwendet werden, außer für weitere Geschenkgutscheine.',
    order: {
      number: 'Bestellnummer',
      email_text: 'Deine Email',
      email_info_text:
        'Falls du innerhalb von 10 Minuten nach der Buchung keine Bestätigungsmail erhältst, dann überprüfe bitte alle betreffenden E-Mail-Ordner: Spam, Junkmail, Werbung usw.',
      invoice_details: 'Rechnungsempfänger',
      title: 'Bestellung',
      thankyou_text: 'Vielen Dank! Deine Bestellung ist bei uns eingegangen.'
    },
    thank_you: {
      applied_coupon: 'Angewendeter Coupon',
      applied_voucher: 'Angewendeter Gutscheincode'
    },
    shipping_total: 'Bearbeitungs- und Versandgebühr',
    empty_cart_warning: 'Sie können keine Bestellung erstellen, wenn sich keine Artikel im Warenkorb befinden.'
  },
  form: {
    first_name: 'Vorname',
    last_name: 'Nachname',
    name: 'Name',
    email: 'E-Mail-Adresse',
    address: 'Straße und Hausnummer',
    address_additional: 'Zusätzliche Addresse',
    street: 'Straße',
    street_number: 'Straße und Hausnummer',
    number: 'Hausnummer',
    city: 'Ort',
    postcode: 'Postleitzahl',
    country: 'Land',
    phone: 'Mobilfunknummer',
    company: 'Name der Firma',
    tax_id: 'Steueridentifikationsnummer',
    notes: 'Anmerkungen',
    additional_information: 'Zusätzliche Informationen',
    phone_notice: 'Über diese Nummer wirst du im Falle von Änderungen der {brand} informiert.',
    confirm: 'Bestätigen',
    participants: 'Teilnehmer*innen',
    language: 'Sprache',
    start_time: 'Startzeit',
    separate_invoice: 'Ich benötige eine separate Rechnung',
    phone_number: 'Rufnummer',
    birthday: 'Geburtstag',
    venue: {
      options: [
        {
          label: 'Ja, die Location steht bereits fest',
          value: 'have_venue'
        },
        {
          label: 'Nein, bisher noch nicht',
          value: 'no_venue'
        }
      ]
    },
    validations: {
      required_field: 'Feld ist erforderlich',
      name_minlength: 'Der Name muss mindestens 2 Buchstaben haben.',
      valid_email: 'Bitte geben Sie eine gültige E-Mail-Adresse an.',
      valid_city: 'Der von Ihnen eingegebene Stadtname scheint nicht gültig zu sein',
      valid_postcode: 'Die Postleitzahl muss mindestens 3 Buchstaben haben.',
      valid_phonenumber: 'Bitte geben Sie eine gültige Telefonnummer ein.',
      valid_tax_id: 'Die Steuernummer muss aus mindestens 3 Buchstaben bestehen.',
      numeric: 'Dieses Element sollte eine Zahl sein.'
    }
  },
  payment: {
    processing: 'Auftragsbearbeitung...',
    failed_title: 'Fehlgeschlage Bestellung',
    failed_text: 'Die Bezahlung für Bestellung #%s von %s ist fehlgeschlagen. Bitte versuche es erneut.',
    failed: {
      title: 'Zahlung fehlgeschlagen',
      text: 'Wir können deine Zahlung leider nicht abschließen. Dein Warenkorb ist für 30 Minuten gespeichert.',
      back_to_cart: 'Zurück zum Warenkorb',
      other_payment_method: 'um eine andere Zahlungsmethode zu wählen',
      contact_support_button: 'Kontakt zum Support'
    },
    pending: {
      title: 'Zahlungsabwicklung',
      text: 'Bitte schließe oder aktualisiere die Seite nicht. Wir wickeln deine Zahlung gerade ab.'
    },
    error: {
      updating_cart: 'Fehler beim Aktualisieren des Warenkorbs',
      payment_failed: 'Fehler bei der Zahlungsabwicklung'
    }
  },
  footer: {
    constent_preferences: 'Cookie-Einstellungen',
    customer_service: 'Kundenservice',
    offer: 'Angebote',
    social_media: 'Social Media',
    countries: {
      de: 'Deutschland',
      ch: 'Schweiz',
      nl: 'Niederlande',
      uk: 'UK',
      at: 'Österreich'
    },
    instagram_text:
      'Folge uns auf Instagram, verlinke deine Bilder mit dem Hashtag {hashtag} und habe monatlich die Chance eine {brand} für 2 Personen zu gewinnen und von uns gerepostet zu werden.',
    cookie_button_text: 'Zustimmen',
    cookie_text:
      'Diese Website verwendet Cookies – nähere Informationen dazu und zu Ihren Rechten als Benutzer finden Sie in unserer Datenschutzerklärung. Klicken Sie auf „Zustimmen”, um Cookies zu akzeptieren.'
  },
  newsletter: {
    footer_title: 'Newsletter',
    placeholder_email: 'E-Mail',
    placeholder_city: 'Wähle deine Stadt',
    button_submit_text: 'Abschicken',
    button_send_text: 'Jetzt anmelden',
    button_sent_text: 'Sent',
    widget_title: 'Folge uns in die Welt der Kreativ-Flows',
    event_sold_out_title: 'Warteliste',
    event_sold_out_text:
      'Aktuell ist diese ArtNight ausgebucht. Wir informieren dich, sobald es neue Daten oder freie Spots dafür gibt.',
    artnight: {
      subscribed_text:
        'Fast geschafft! Du hast soeben eine Email erhalten - einfach Anmeldung bestätigen und ArtNight News erhalten!',
      homepage_text:
        'Neue Events und Angebote? Wann kommt ArtNight endlich in deine Stadt? Mit dem ArtNight Newsletter weißt du sofort Bescheid. Melde dich jetzt an und werde regelmäßig über neue Termine und tolle Aktionen informiert!',
      thank_you_text:
        'Du hast Dich erfolgreich für unseren Newsletter angemeldet. Willkommen in unserem ArtNight-Universum. Ab jetzt erwarten Dich exklusive Rabattcodes, Gewinnspiele und der heißeste Shit rund um ArtNight. Darauf stoßen wir erstmal an!?'
    },
    footer_text: 'Melde dich jetzt an und werde regelmäßig über neue Termine und tolle Aktionen informiert!',
    validations: {
      email: 'Die eingegebene Email Adresse ist nicht korrekt.',
      required: 'E-Mail ist ein Pflichtfeld.',
      city_required: 'Stadt ist ein Pflichtfeld.'
    },
    landing: {
      title: 'Hurra, Du bist dabei!',
      text_1: 'Du hast Dich erfolgreich für unseren Newsletter angemeldet. Willkommen in unserem {brand}-Universum.',
      text_2:
        'Ab jetzt erwarten Dich exklusive Rabattcodes, Gewinnspiele und der heißeste Shit rund um {brand}. Darauf stoßen wir erstmal an! ?'
    }
  },
  press: {
    reviews: 'Das sagt unsere Community',
    contact: 'Pressekontakt',
    title: 'Presseportal',
    our_story: {
      title_one: 'Unsere Geschichte',
      paragraph_one:
        'ArtNight wurde 2016 von Aimie-Sarah Carstensen gegründet – mit der Vision, Menschen durch Kreativität im echten Leben zusammenzubringen. In entspannter Atmosphäre schaffen Teilnehmende etwas mit ihren eigenen Händen und nehmen nicht nur ein Kunstwerk mit nach Hause, sondern auch ein echtes Erlebnis. </br> Ganz nach dem Motto:<i> Mal wieder etwas Neues ausprobieren. Mal wieder gemeinsam lachen. Mal wieder stolz sein.</i> </br> Was als kleine Idee begann, ist heute ein europaweit bekanntes Eventkonzept mit über <b>1,5 Millionen Teilnehmenden, über 1.000 Events pro Monat</b> und einem Netzwerk von <b>mehr als 300 Künstler:innen</b> in über <b>60 Städten</b>. ArtNight ist Marktführer im Bereich kreative Erlebnisse – von klassischen Malkursen bis hin zu innovativen Formaten wie <i>ArtNight Beats, Paint Your Partner oder Aquarell im Park</i> – für Erwachsene und Kinder gleichermaßen. Ob mit Freund:innen, Kolleg:innen oder beim ersten Date: Bei ArtNight entstehen echte Verbindungen und unvergessliche Momente.',
      title_two: 'Unsere Mission',
      paragraph_two:
        'Wir bringen Menschen durch Kreativität offline zusammen – für echte Verbindungen, kreativen Flow und Erinnerungen, die bleiben.Wir kombinieren Kreativität mit echten Begegnungen – für unvergessliche Erlebnisse, die für alle zugänglich sind. ArtNight inspiriert Menschen, ihre Kreativität zu entdecken, in den Flow zu kommen und im Hier und Jetzt zu verbinden. Wir glauben daran, dass Kreativität in jedem Menschen steckt – und dass sie dann am meisten bewegt, wenn wir sie miteinander teilen.',
      contact: '<b>Für Presse- und Interviewanfragen wenden Sie sich bitte an:</b>'
    },
    title_section1: 'Pressemitteilungen',
    title_section2: 'Pressespiegel',
    title_section3: 'Media Downloads'
  },
  validations: {
    email: 'Die eingegebene Email Adresse ist nicht korrekt.',
    required: 'Feld ist erforderlich',
    min_length: 'Das Feld muss mindestens {min} Zeichen enthalten.',
    city: 'Der von Ihnen eingegebene Stadtname scheint nicht gültig zu sein',
    postcode: 'Die Postleitzahl muss mindestens {min} Buchstaben haben.',
    tax_id: 'Die Steuernummer muss aus mindestens {min} Buchstaben bestehen.'
  },
  event_attendee_registration_success: {
    registration: 'Deine Registrierung war erfolgreich!',
    confirmation_one: 'Bitte halte diese Bestätigung vor deiner',
    confirmation_two: 'bereit, um sie deinem/deiner Workshopleiter:in zu zeigen.',
    fun: 'Wir wünschen dir ganz viel Spaß!'
  },
  event_attendee_registration: {
    headline: 'Bitte trage dich in unsere Teilnehmerliste ein!',
    no_events_found: 'Sorry, heute findet leider kein Event statt.'
  },
  listings: {
    sort_by: 'Sortieren nach:',
    video_courses: {
      hero_title: 'ArtNight Videokurse',
      hero_description:
        'Mit unseren neuen Videokursen stehen dir eine Vielzahl von Motiven zur Auswahl, die du ganz entspannt in deinem eigenem Tempo malen kannst.',
      bundles_title: 'Bundles',
      bundles_description: 'Unsere Videobundles: Thematisch passende Videokurse zusammen kaufen und dabei Geld sparen!',
      courses_title: 'Einzelne Videokurse',
      bundles_courses_count: 'ENTHÄLT KEINE VIDEOKURSE | ENTHÄLT EINE VIDEOKURSE | ENTHÄLT {count} VIDEOKURSE'
    },
    sortings: {
      'slug:asc': 'Alphabetisch, A-Z',
      'slug:desc': 'Alphabetisch, Z-A',
      'price:asc': 'Preis, niedrig nach hoch',
      'price:desc': 'Preis, hoch nach niedrig',
      'created_at:asc': 'Datum, alt zu neu',
      'created_at:desc': 'Datum, neu zu alt'
    }
  },
  group_events: {
    head_title: 'ArtNight: Erstellen Sie Ihre private Gruppenveranstaltung',
    back_to_page: 'Zurück zur Übersicht',
    details: {
      location_sub: 'Bitte gib hier die Adresse des gewünschten Veranstaltungsortes an',
      error_max_participants: '60'
    },
    options: {
      eventDateTime: '{date} um {time}',
      eventDate: 'Datum',
      eventTime: 'Time',
      eventLocation: 'Ort',
      locationCity: 'City',
      locationAddress: 'Address',
      locationPostalCode: 'Postal Code',
      locationContact: 'Kontakt',
      numberOfParticipants: 'Anzahl Teilnehmer*innen'
    },
    thank_you: {
      heading: 'Yay! Danke für deine Buchung.',
      subheading: 'Wir melden uns bei dir mit weiteren Infos zu eurem Event.',
      back_to_home: 'Zurück Zur Homepage',
      links: 'Hast du noch fragen? {email} oder {phone}'
    },
    header: {
      title: 'Lass uns deine ArtNight planen – in nur vier Schritten!',
      subtitle:
        'Wir stellen dir einige Fragen, um die perfekte ArtNight für euer Event zu finden. Du kannst danach noch immer alles ändern.',
      subtitle_v2:
        'Organisiere mit ArtNight dein Team Event, deine private Geburtstagsparty oder andere kreative Feierlichkeiten'
    },
    participants: {
      title: '1 – Teilnehmende',
      subtitle: 'Bis zu {participants} Personen bleibt der Mindestpreis von {price} € bestehen',
      count: 'Wie viele Personen werden teilnehmen?',
      less_than_participants:
        'Ihr seid weniger als {participants} Personen? Auch bei öffentlichen ArtNights könnt ihr als Gruppe teilnehmen.',
      public_artnight_link: 'Zu den öffentlichen ArtNights',
      more_than_participants:
        'Bei Buchungen über 25 Personen kümmern wir uns gerne individuell um deine Anfrage. Du kannst uns diese im nächsten Schritt unverbindlich zukommen lassen.'
    },
    location: {
      title: '2 – Location',
      subtitle_1: 'Wie möchtet ihr euer Event veranstalten?',
      subtitle_2: 'Wo soll euer Event stattfinden?',
      subtitle_3: 'Und in was für einer Location?',
      options: {
        customer: 'Eigene Räumlichkeiten'
      },
      cta: {
        title: 'Event vor Ort',
        feature_line_1: 'Alle Materialien werden von uns mitgebracht',
        feature_line_2: 'Event in eurer Location',
        button_selected: 'Ausgewählt',
        price: 'Ab {price}'
      },
      city_label: 'Ort',
      postcode_label: 'Postleitzahl',
      telefonnummer_label: 'Telefonnummer'
    },
    themes: {
      title: '3 – Motiv-Wahl',
      subtitle: 'Keine Sorge: Das Motiv kann auch später noch geändert werden, solltet ihr euch umentscheiden.',
      details_modal_title: 'Infos zum Motiv',
      modal_title: 'Alle ArtNight Motive ({count})',
      load_more_text: 'Alle {count} Motive durchsuchen',
      description_title: 'Was euch erwartet',
      details_text: 'Details anzeigen'
    },
    date_time: {
      title: '4 – Datum & Uhrzeit',
      subtitle: 'Events, die weniger als 14 Tage im Voraus angefragt werden, prüfen wir gerne auf ihre Machbarkeit.',
      time: 'Um welche Uhrzeit soll euer Event stattfinden?',
      flexible_time: 'Wir sind zeitlich flexibel',
      label: 'Uhrzeit'
    },
    summary: {
      subtitle: 'Übersicht deines Events',
      button_text: 'Weiter zur Zusammenfassung',
      button_short_text: 'Zur Zusammenfassung',
      total_text_with_tax: 'Gesamtbetrag (inkl. MWST)',
      participants_text: '{price} x {number} Teilnehmende',
      total_text: 'Gesamtbetrag'
    },
    footer: {
      button: 'Dein Event buchen'
    },
    banner: {
      text: 'Aber uns gibt es auch maßgeschneidert.',
      sub_text: 'Für <b>private Gruppen</b> oder <b>Team-Events</b>.'
    },
    request: 'Unverbindlich anfragen'
  },
  instagram: {
    title: 'Folge uns für noch mehr Inspiration',
    link_text: 'Zum ArtNight Instagram'
  },
  founder: {
    title: 'Aimie, Gründerin von ArtNight',
    text: '„Artnight ist eine Plattform und eine kreative Community, die glaubt, dass Kreativität der Schlüssel zu einem erfüllten Leben ist.“',
    ctaText: 'Mehr über uns',
    video_title: 'Erlebe spannende Malkurse mit ArtNight!'
  },
  offline_message: 'Du bist offline. Einige Funktionen sind möglicherweise nicht verfügbar.',
  product_page: {
    title: {
      events: 'Malkurse in deiner Nähe | {themeCategoryNames} malen',
      motiv: 'Alle Kategorien | {themeCategoryNames} malen',
      city: 'Malkurse in {city} | {themeCategoryNames} malen in {city} ',
      kids: 'Malen mit Kindern'
    },
    sub_title: 'Wähle ein Motiv für deine kreative Auszeit'
  },
  auth: {
    register_success: 'Konto bestätigt! Logg dich ein, um weiterzumachen.',
    register_title: 'Konto erstellen',
    register_subtitle: 'Erstelle ein ArtNight-Konto, um deine Erfahrungen zu verbessern!',
    register_success_email: 'Schau bitte in deinem Posteingang nach, um deine E-Mail-Adresse zu bestätigen.',
    register_login: 'Ich habe schon ein Konto',
    register_button: 'Erstellen',
    register_confirmation: 'E-Mail bestätigt! Bitte einloggen.',
    field_first_name: 'Vorname',
    field_last_name: 'Nachname',
    field_email: 'E-Mail-Adresse',
    field_password: 'Passwort',
    field_current_password: 'Aktuelles Passwort',
    field_new_password: 'Neues Passwort',
    field_password_repeat: 'Passwort wiederholen',
    field_newsletter: 'Erhalte regelmäßige Updates in unserem Newsletter.',
    login_title: 'Login',
    login_subtitle: 'Wenn du bereits ein ArtNight-Konto hast, melde dich mit deiner E-Mail-Adresse an.',
    login_remember_title: 'Eingeloggt bleiben',
    login_remember_subtitle: 'Meine Anmeldedaten für das nächste Mal speichern',
    login_button: 'Anmelden',
    logout_button: 'Abmelden',
    login_register_title: 'Registrieren',
    login_register_subtitle: 'Erstelle jetzt dein ArtNight-Konto!',
    forgotten_password: 'Passwort vergessen',
    login_register_list_1: 'Erstelle und verwalte deinen Wunschzettel für künftige Einkäufe und Geschenkideen',
    login_register_list_2: 'Finde alle deine Bestellung in einer Übersicht',
    login_register_list_3: 'Erhalte unseren Newsletter mit Updates zu neuen Produkten und Sonderangeboten',
    forgot_password_title: 'Passwort vergessen',
    forgot_password_subtitle:
      'Gib deine E-Mail-Adresse ein und wir schicken dir einen Link, um ein neues Passwort zu erstellen.',
    forgot_password_button: 'E-Mail senden',
    forgot_password_register_link: 'Ein Konto erstellen',
    forgot_password_help_title: 'Brauchst du Hilfe?',
    forgot_password_help_button: 'Kontakt Support',
    forgot_password_help_subtitle:
      'Wenn Sie Probleme haben, sich anzumelden oder sich an Ihre E-Mail-Adresse zu erinnern, wenden Sie sich bitte an unseren Kundendienst.',
    reset_password_title: 'Passwort zurücksetzen',
    reset_password_success_title: 'Bestätigtes Passwort',
    reset_password_success_subtitle: 'Dein Passwort wurde zurückgesetzt, bitte melde dich an.',
    reset_password_subtitle: 'Erstelle ein neues Passwort für deinen ArtNight Account.',
    menu_account: 'Konto',
    menu_my_artnight: 'Meine ArtNight',
    menu_overview: 'Übersicht',
    menu_orders: 'Bestellungen',
    menu_my_account: 'Konto bearbeiten',
    menu_cs: 'Kundenservice',
    menu_rebooking: 'Ticketumbuchung',
    menu_support: 'Kundenservice kontaktieren',
    menu_calendar: 'Kalender',
    overview_title: 'Konto Übersicht',
    overview_subtitle: 'Willkommen zu deinem persönlichen ArtNight-Bereich!',
    no_order_history_title: 'Keine Bestellhistorie',
    no_order_history_subtitle: 'Bitte kontaktiere uns, falls du Bestellungen vermisst.',
    no_order_history_section: 'ArtNight Konto',
    not_logged_in_title: 'Bitte Einloggen',
    not_logged_in_subtitle: 'Oder registriere dich mit deiner E-Mail Adresse',
    edit_title: 'Konto bearbeiten',
    edit_subtitle: 'Dein ArtNight-Konto ansehen oder ändern.',
    orders_subtitle: 'Sieh dir deine ArtNight-Bestellhistorie an.',
    latest_order_section: 'Letzte Bestellung',
    next_event_section: 'Nächste ArtNight',
    error_invalid_credentials: 'Fehler - Falsches Passwort, bitte versuche es erneut.',
    error_unconfirmed_email: 'Benutzerkonto ist nicht verifiziert',
    resend_confirmation_text: 'Bestätigungs-E-Mail erneut senden',
    error_sending_confirmation:
      'Es gibt ein Problem mit der Bestätigung Ihrer E-Mail, bitte kontaktieren Sie unser Support-Team.'
  },
  account_edit: {
    title: 'Konto bearbeiten',
    sub_title: 'Dein ArtNight-Konto ansehen oder ändern',
    specification_title: 'Deine Angaben',
    password_title: 'Passwort',
    password_address: 'Adresse',
    buttons: {
      password: 'Passwort ändern',
      delete_account: 'Konto löschen',
      edit_user_data: 'Angaben bearbeiten',
      edit_address: 'Adresse ändern',
      save_changes: 'Änderungen speichern',
      save_new_password: 'Neues Passwort speichern'
    }
  },
  account_calendar: {
    date: 'Datum',
    hour: 'Zeit',
    tickets: 'Tickets',
    host: 'Künstler*in',
    place: 'Standort',
    place_popup: {
      title: 'Wann wird der Veranstaltungsort bekannt gegeben?',
      text: 'Der Veranstaltungsort wird im Regelfall spätestens eine Woche im Voraus veröffentlicht. 48 Std. vor Beginn erhältst du ebenfalls noch einmal eine E-Mail mit allen Informationen und auch der genauen Adresse des Veranstaltungsorts.'
    },
    modified: 'Änderungen',
    cancelled: 'Abgesagt',
    order_cancel: 'Bestellung stornieren',
    past_events: 'Vergangene ArtNights',
    view_order: 'Bestelldetails ansehen',
    to_calendar: 'Speichern im Kalender',
    see_changes: 'Änderungen anzeigen',
    subtitle: 'Schau dir alle deine ArtNight-Events an',
    dropdown: {
      desc: 'Früheste bis späteste',
      asc: 'Späteste bis Früheste '
    },
    inline_filters: {
      future: 'Zukünftig',
      past: 'Vergangene',
      all: 'Alle'
    },
    event_changes: {
      modified: 'Änderung',
      previous: 'Vorher',
      current: 'Aktuell',
      eventDuration: 'Dauer',
      theme: 'Motiv',
      venue: 'Standort',
      price: 'Preis',
      level: 'Level'
    },
    show_all_events: 'Alle ArtNights anzeigen'
  },
  order_history: {
    date: 'Bestelldatum'
  },
  order_details: {
    title: 'Bestelldetails',
    order_number_ua: 'Bestellnummer',
    order_date: 'Bestelldatum',
    tickets: 'Tickets',
    event_date: 'Event datum',
    sold: 'Saldo',
    deadline: 'Verfall',
    copy: 'Kopieren',
    copied: 'Kopiert',
    order_total: 'Zwischensumme',
    discount: 'Rabatt',
    giftcard: 'Gutschein',
    paid_total: 'Gesamt',
    payment_method: 'Zahlungsmethode',
    order_number: 'Bestellbestätigung',
    download_pdf: 'PDF herunterladen',
    rebooking_ticket: 'Diese Tickets umbuchen',
    view_calendar: 'Kalender anzeigen',
    quantity: 'Anzhahl',
    view_voucher: 'Gutschein Guthaben',
    available_voucher: 'Vergebene Gutscheine',
    avalaible_voucher_pdf: 'Geschenkgutschein PDF',
    download_canceled_confirmation: 'Stornierte Bestätigung herunterladen',
    order_cancelled: 'Bestellung storniert',
    refunded_method: 'Erstattet',
    close_button: 'Schließen'
  },
  product_listing: 'Malkurse anzeigen',
  thank_you_page: {
    title: 'Vielen Dank!',
    subtitle: 'Deine Bestellung war erfolgreich. Du erhältst in Kürze eine E-Mail-Bestätigung.',
    booking_summary: {
      title: 'Deine ArtNight',
      subtitle:
        'Lade die Veranstaltungsdetails in deinen Kalender herunter oder mach dir eine Notiz zur Zeit und zum Ort der Veranstaltung.',
      map_button: 'Ansicht in Google Maps',
      calendar_button: 'Zum Kalender hinzufügen'
    },
    account: {
      title: 'Konto erstellen',
      subtitle: 'Deine ArtNight-Events, Bestellhistorie & mehr.',
      already_registered: 'Schon angemeldet?',
      login: 'Jetzt einloggen',
      create: 'Erstellen'
    },
    voucher: {
      title: 'Deine ArtNight Gutschein',
      subtitle:
        'Du bekommst die Gutscheinkarte als PDF per E-Mail zugeschickt. Die Details zur Gutscheinkarte findest du in deinem ArtNight-Konto.',
      button: 'PDF speichern'
    },
    online_event: {
      subtitle:
        'Lade die Veranstaltungsdetails in deinen Kalender herunter. Du erhältst den Zoom-Link, um am ArtNight Online-Event teilzunehmen, 24 Stunden vor Beginn.',
      material_kit: '1x Material Set'
    }
  },
  city_selector: {
    online_event: 'Online Malkurse',
    all_cities: 'Alle ArtNight Städte',
    search_host: 'Suche eine:n Künstler:in'
  },
  group_booking_v2: {
    header: 'Lass uns deine ArtNight planen',
    participants: {
      title: 'Teilnehmende',
      subtitle: 'Bis zu 10 Personen bleibt der Mindestpreis von 490 € bestehen',
      optional: 'Optionale Angaben',
      event_type: 'Veranstaltungstyp',
      event_type_place_holder: 'Bitte auswählen',
      options: {
        team_event: 'Team-Veranstaltung',
        birthday: 'Geburtstag',
        summer_party: 'Sommerfest',
        bachelorette_party: 'Junggesellinnenabschied',
        xmas: 'Weihnachtsfeier',
        other: 'Sonstiges'
      },
      language: 'Spraches des Events',
      notes: 'Hinweis',
      notes_placeholder: 'Einen bestimmten Kursleiter anfragen oder Details über den Ort hinterlassen'
    },
    location: {
      title: 'Location',
      subtitle: 'Bestätige die Standortdetails deiner ArtNight',
      details: 'Location Details',
      field_name: 'Name des Veranstaltungsortes',
      field_name_text:
        'Falls es sich um eine private Adresse handelt, gib hier bitte den Namen auf der Klingel an. Wenn es ein Café, Restaurant oder Event-Location ist, gib bitte den Namen des Ortes an.',
      premium_title: 'Premium Optionen',
      premium_option_text: 'ArtNight Partner',
      premium_text: 'Wir suchen für dich eine passende Location aus unserem Partner Portfolio!',
      city_text: 'Meine Stadt ist nicht aufgelistet',
      custom_city_text: 'Andere Stadt ausgewählt',
      modal_title: 'Meine Stadt ist nicht aufgelistet',
      modal_button: 'Antrag einreichen',
      modal_button_close: 'Abbrechen',
      modal_text:
        'Sollte deine Stadt nicht auswählbar sein, dann schicke uns gerne eine Anfrage!<br /><br />Unser Team wird versuchen für dich das Event zu konzipieren und einige geeignete Künstlerin zu finden.<br /><br />Bitte beachte dass dafür eine Reisekosten-pauschale von ca. 1 EUR pro Kilometer anfällt.'
    },
    date_time: {
      title: 'Datum & Uhrzeit',
      subtitle: 'Datum mit 14 Tagen Vorlaufzeit wählen',
      time_text: 'Bitte beachte dass wir eine Stunde vor und nach dem Event vor Ort sein werden.'
    },
    details: {
      title: 'Details',
      subtitle:
        'Bitte bestätige die folgenden Angaben, damit wir deine Anfrage für die private ArtNight bearbeiten können.',
      title1: 'Details Kontaktperson',
      title2: 'Details zur Rechnungsstellung',
      field_email: 'E-mail Adresse',
      field_phone: 'Handynummer',
      field_company: 'Name des Unternehmens',
      field_address: 'Rechnungsadresse',
      field_postcode: 'Postleitzahl',
      field_country: 'Land',
      field_vat_id: 'Tax-ID',
      send_button: 'Senden'
    },
    save_and_next: 'Speichern & Weiter',
    total_cost: 'Gesamtkosten',
    pay_by_invoice: 'Per Rechnung bezahlen',
    send_request: 'Anfrage senden',
    requested: {
      title: 'Super!',
      subtitle:
        'Vielen Dank für deine Anfrage! <br /><br />Wir werden uns innerhalb der nächsten 2-3 Werktage bei dir melden!<br /><br /> Solltest du in der Zwischenzeit Rückfragen habe, dann melde schicke gerne direkt eine E-Mail an <a href="mailto:private-events@artnight.com">private-events@artnight.com</a>'
    },
    motiv: {
      title: 'Motiv',
      subtitle: 'Wähle ein Motiv aus! Das Motiv kann bis 7 Tage vor dem Event frei geändert werden.',
      select_later: {
        title: 'Später entscheiden',
        subtitle: 'Buche jetzt und bestätige das Thema spätestens 7 Tage vor deiner ArtNight.',
        more_info: 'Mehr erfahren',
        popup_text:
          'Gerne kannst du hier ein Acrylmotiv für deine ArtNight auswählen. Falls du dich für ein Aquarellmotiv entscheidest, gib uns bitte direkt bei der Buchung Bescheid. Hinterlasse eine Nachricht im Abschnitt für Teilnehmer.',
        popup_subtext: 'Auf Wunsch bieten wir auch gerne XXL-Leinwände an.',
        motiv: 'Motiv ausstehend'
      },
      premium_option: {
        title: 'Premium Optionen',
        details: {
          opt1: 'Individuelle Motivkonzeption',
          opt2: 'Angepasst auf Ihre Marke ',
          opt3: 'Wir machen jede Idee ArtNight tauglich und für alle einfach zu malen'
        },
        wish_motiv: 'Wunschmotiv',
        min_participants: 'Mindestens 25 Teilnehmer'
      },
      cancel: 'Abbrechen'
    }
  },
  feedback: {
    title: 'Teile dein Feedback mit uns',
    comment: 'Dein kommentar',
    steps: {
      one: {
        title: 'Motiv',
        sub_title: 'Bewerte die Schwierigkeit und das Erlebnis des Motivs, das du erstellt hast.',
        rating_title: 'Wie zufrieden bist du mit deinem Kunstwerk?',
        improvement: 'Was können wir verbessern, damit das Motiv während der ArtNight noch besser umsetzbar ist?',
        options: {
          one: 'Mehr Zeit',
          two: 'Bessere Anleitung',
          three: 'Mehr individuelle Betreuung',
          four: 'Bessere Verteilung der Materialien',
          five: 'Sonstiges'
        }
      },
      two: {
        title: 'Künstler*in',
        sub_title: 'Bitte bewerte deine Erfahrung mit Artist, {value}.',
        rating_title: 'Wie bewertest du die Leistung des Künstlers?',
        improvement: 'Was kann die/der Künstler*in in Zukunft verbessern?',
        compliments: 'Teile die/der Künstler*in mit, was dir an der ArtNight gefallen hat'
      },
      three: {
        title: 'Location',
        sub_title: 'Erzähl uns, wie deine Erfahrung mit dem Ort war.',
        rating_title: 'Wie hat dir die Location gefallen?',
        improvement: 'Was kann die Location verbessern, um eine noch entspanntere ArtNight zu bieten?',
        options: {
          one: 'Bessere Beleuchtung',
          two: 'Tische mit mehr Platz',
          three: 'Bessere Bedienung',
          four: 'Mehr Angebot an Essen oder Trinken',
          five: 'Weniger Lärm',
          six: 'Bessere Park-Möglichkeiten',
          seven: 'Bessere Verbindung zu ÖPVN',
          eight: 'Sonstiges'
        }
      }
    },
    thank_you:
      'Dein Feedback wurde registriert. Wenn du Fragen hast oder Änderungen vornehmen möchtest, wende dich bitte an den ',
    outdated_title: 'Ups',
    outdated_link: 'Dein Link ist leider abgelaufen. Wenn du Feedback zu diesem Event hast, melde dich gerne beim'
  },
  homepage: {
    hero: {
      text: 'Dein Erlebnis. <br/> Dein Kunstwerk.',
      cta: 'Aktuelle Angebote ansehen'
    },
    navigation_grid: {
      acryl: 'Acryl Malkurse',
      aquarell: 'Aquarell Workshops',
      voucher: 'Gutschein kaufen',
      kids: 'ArtNight Kids',
      online: 'Online-Malkurs',
      group: 'Private Gruppen'
    },
    popular_themes: {
      title: 'Beliebte Motive',
      motiv: {
        structure: 'Struktur Abstrakt',
        banksy: 'Banksy: Street-Art-Kollektion',
        spatula: 'Abstraktes Arbeiten mit dem Spachtel',
        inspiration: 'Abstrakt – Inspiration',
        glitter: 'Glitzer Abstrakt',
        kids_eule: 'ArtNight Kids: Eule',
        partner: 'Paint your Partner',
        eule: 'Eule',
        layering: 'Abstract Layering',
        city_passenger: 'Stadtspaziergang',
        dancing: 'Tänzerin im Licht',
        lyon: 'ArtNight Löwe',
        wind: 'Vom Winde verweht',
        aquarell_flower: 'Aquarell: Blüten und Blätter',
        flowers: 'Blumenrad',
        under_water: 'Unterwasser Welt',
        monet: 'ArtNight Klassik: Monet - Seerosen',
        frida_acryl_collage: 'ArtNight Klassik: Frida Kahlo Acryl Collage',
        zuckerwatte_wolken: 'Zuckerwatte-Wolken',
        goldener_see: 'Goldener See'
      },
      cta: 'Mehr entdecken'
    },
    usps: {
      title: 'Warum ArtNight?',
      options: {
        1: {
          title: 'ArtNight ist für jede*n',
          description: 'Egal, ob du schon mal gemalt hast oder noch nie einen Pinsel in der Hand hattest.'
        },
        2: {
          title: 'Alles ist vorbereitet',
          description: 'Dich erwartet ein liebevoll gestaltetes Set-up inkl. Leinwand, Farben, Pinsel und Schürze'
        },
        3: {
          title: 'Deine kreative Auszeit',
          description: 'Bereits über 1 Million Teilnehmer*innen haben mit ArtNight ihre Kreativität wiederentdeckt'
        }
      }
    },
    message: {
      text: '„Wir glauben fest daran, dass Kreativität der Schlüssel zu einem erfüllten Leben ist. Das Potential dazu steckt in allenvon uns. Wir müssen es nur entdecken.“',
      signature: 'Aimie, Gründerin von ArtNight'
    },
    new_themes: {
      title: 'Neue ArtNight-Motive und -Erlebnisse',
      motiv: {
        fruit: 'Pixel – Discofrüchte',
        disco: 'Pixel – Discokugel',
        cat: 'ArtNight Kids: Grumpy Cat',
        sunrise: 'Tequila Sunrise',
        beat: 'ArtNight Beats',
        cliff: 'Küstenlandschaft – Felsen',
        parc: 'Aquarell im Park',
        inspiration: 'Abstrakt - Inspiration',
        woman: 'Unter der Sonne des Südens',
        oranges: 'Paint and Frame: Orangen',
        lemons: 'Paint and Frame: Zitronen',
        oysters: 'The Art of Oyster Painting and Decoupage',
        kids: 'ArtNight Kids Aquarell: Kleine Monsterwerkstatt',
        winenpaint: 'Wine & Paint: Struktur Abstrakt',
        afro_beats: 'ArtNight Beats Afro Beats',
        frog: 'ArtNight Kids: Herr Frosch'
      },
      cta: 'Neueste ArtNight-Motive ansehen'
    },
    city_select: {
      button: 'Städte auswählen',
      title: 'ArtNights nach Städten finden',
      show_citie: 'Events in diesen Städten',
      close: 'Schließen'
    },
    online_events: {
      title: 'Online-Malkurse für zu Hause',
      motiv: {
        poney: 'Pink Pony Club',
        frida: 'Frida Mocha Mousse',
        aquarell: 'Aquarell: Abstrakt',
        koi: 'Koi',
        partner: 'Paint Your Partner',
        flower: 'Blumenrad',
        sun: 'Unter der Sonne des Südens',
        ski: 'Abfahrt im Schnee',
        sommerwind: 'Sommerwind',
        lavender: 'Colorful Lavender',
        lemon_tree: 'Lemon Tree',
        la_dolce_vita: 'La Dolce Vita',
        vom_winde_verweht: 'Vom Winde verweht',
        wattwanderung: 'Wattwanderung',
        sternennacht: 'Sternennacht'
      },
      cta: 'Alle Online-Malkurse anzeigen'
    },
    group_events: {
      title: 'Deine private ArtNight',
      text: 'Wir bringen ArtNight zu deinem Team Event, JGA oder zu deiner Geburtstagsfeier.'
    },
    how_it_works: {
      title: 'So funktioniert ArtNight',
      paragraphs: {
        find: {
          title: 'Entdecken',
          text: 'ArtNights finden täglich in über 60 Städten in Deutschland und Österreich statt. Entdecke eine Vielzahl an Terminen und Erlebnissen – und wähle das Event, das zu dir passt.',
          subtext:
            'Gib einfach deine  <a href="/events" style="text-decoration: underline;">Stadt</a>  ein oder stöbere durch alle verfügbaren <a href="/motiv" style="text-decoration: underline;">Motive</a> und lass dich inspirieren.'
        },
        book: {
          title: 'Buchen',
          text: 'Sichere dir dein Wunsch-Event mit nur wenigen Klicks – und trage dir deine kreative Auszeit direkt in den Kalender ein.',
          subtext:
            'Tipp: Du hast einen ArtNight <a href="/malkurs-gutschein" style="text-decoration: underline;">Gutschein</a>? Den kannst du jederzeit für deine Buchung einlösen.'
        },
        create: {
          title: 'Erleben',
          text: 'Deine ArtNight wird liebevoll von unseren Künstler:innen vorbereitet – mit allem, was du brauchst. <br/> Komm an, tauch ein ins kreative Erlebnis und nimm am Ende dein selbst gemaltes Kunstwerk mit nach Hause.</br> Unvergessliche Erinnerungen inklusive – ob allein, mit Freund:innen oder als Geschenk an dich selbst.',
          subtext: ''
        }
      }
    },
    events_category: {
      title: 'ArtNight Event Kategorien',
      options: {
        bestseller: 'Bestseller',
        abstract: 'Abstrakt',
        new: 'Neuheiten',
        landscape: 'Landschaften',
        nature: 'Botanik & Natur',
        people: 'Menschen',
        animals: 'Tiere',
        street: 'Pop & Street Art',
        limited: 'Limited Edition',
        specials: 'Specials',
        seasonal: 'Seasonal',
        kids: 'Kids',
        watercolor: 'Aquarell',
        classic: 'Klassische Kunst',
        faces: 'Gesichter',
        symbols: 'Symbole',
        beats: 'Beats & Paint'
      }
    }
  },
  footer_v2: {
    news_letter: {
      title: 'Dein 10% Willkommensrabatt',
      text_part_one:
        'Melde dich für den ArtNight Newsletter an, erhalte bis zu 10% Rabatt auf deine erste Buchung und erfahre als Erstes von Angeboten, Neuheiten und Gewinnspielen! 💌',
      text_part_two:
        'Nach der Anmeldung erhältst du eine E-Mail zur Bestätigung. Der Newsletter ist kostenlos und du kannst dich jederzeit wieder abmelden.',
      email_input: 'E-Mail Adresse ',
      city_input: 'Stadt',
      register: 'Anmelden',
      success: 'Eingereicht'
    },
    theme_categories: {
      acryl: 'Acryl Malkurse',
      watercolor: 'Aquarell Workshops',
      voucher: 'Gutschein Kaufen',
      kids: 'ArtNight Kids',
      online: 'Online-Malkurs',
      group: 'Private Gruppen'
    },
    company: {
      title: 'FIRMA',
      about: 'Über uns',
      jobs: 'Jobs',
      press: 'Presse',
      host: 'Künstler werden',
      location: 'Location werden'
    },
    support: {
      title: 'SUPPORT',
      help: 'Hilfe & Kontakt',
      rebooking: 'Umbuchung'
    },
    legal: {
      agb: 'AGB',
      daten: 'Datenschutz',
      impressum: 'Impressum',
      cookies: 'Cookie-Einstellungen'
    }
  }
};
